import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';

import Dropdown from '@frolight/components/Dropdown';
import useAuth from '@frolight/hooks/useAuth';
import useFormattedLocalizedText from '@frolight/hooks/useLocalizedFormattedText';
import useSignOut from '@frolight/hooks/useSignOut';

const ApplicationHeader = () => {
  const { lftext } = useFormattedLocalizedText();

  const [ loading, setLoading ] = useState(false);
  const { auth } = useAuth();

  const navigate = useNavigate();
  const signOut = useSignOut();

  const onSignOutClick = async () => {
    setLoading(true);
    try {
      await signOut();
    } catch (err) {
      console.error('Sign out error', err);
    } finally {
      setLoading(false);
    }
  };

  const onPreferencesClick = () => {
    navigate('/preferences');
  };

  const getUserAvatarSource = (user) => {
    return user?.avatar ? user.avatar : 'images/avatar_default.png';
  };

  return (
    <header className="application_header">
      <div className="application_header__inner">
        <div className="application_header__logo">
          <Link className="logo_link" to="/">
            <img className="logo_link__img" src="/images/frolight_logo.svg" alt="Frolight logo" />
          </Link>
        </div>
        {
          auth && auth.user && (
            <div className="application_header__tools">
              <ul className="toolbar">
                <li className="toolbar__group">
                  <ul className="toolbar">
                    <li className="toolbar__item">
                      <Dropdown
                        alignEnd={true}
                        buttonContent={
                          (
                            <>
                              <img className="profile_toggle__avatar" src={ getUserAvatarSource(auth.user) } alt={`${auth.user.firstName} ${auth.user.lastName}`} />
                              <span className="profile_toggle__name">{`${auth.user.firstName} ${auth.user.lastName}`}</span>
                            </>
                          )
                        }
                        menuItems={
                          [
                            { label: lftext('components.header.preferences'), clickHandler: onPreferencesClick },
                            { label: lftext('components.header.sign_out'), clickHandler: onSignOutClick, disabled: loading }
                          ]
                        }
                      />
                    </li>
                  </ul>
                </li>
              </ul>
            </div>
          )
        }
      </div>
    </header>
  );

}

export default ApplicationHeader;
